/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const INIT = "INIT";
export const RESET = "RESET";
export const SET_CANVAS = "SET_CANVAS";
export const NEXT_STEP = "NEXT_STEP";
export const PREV_STEP = "PREV_STEP";
export const LOAD_STEP = "LOAD_STEP";
export const LOAD_CANVAS_JSON = "LOAD_CANVAS_JSON";
export const CLEAR = "CLEAR";
export const STORE_STEP = "STORE_STEP";
export const PUSH_STEP = "PUSH_STEP";
export const INCREASE_STEP = "INCREASE_STEP";
export const DECREASE_STEP = "DECREASE_STEP";
export const SET_LOADING = "SET_LOADING";
export const SET_ACTIVE_CONTROL = "SET_ACTIVE_CONTROL";
export const APPLY_TILE_OR_POPART = "APPLY_TILE_OR_POPART";
export const TOGGLE_TILE_POPART_ON_STEP_CHANGE =
  "TOGGLE_TILE_POPART_ON_STEP_CHANGE";
export const SET_CURRENT_UGC_VIEW = "SET_CURRENT_UGC_VIEW";
export const NEXT_CURRENT_UGC_VIEW = "NEXT_CURRENT_UGC_VIEW";
export const SET_SKIP_ALMOST_DONE = "SET_SKIP_ALMOST_DONE";

export const SET_STATE_MANAGER = "SET_STATE_MANAGER";
export const RESTART_STATE_MANAGER = "RESTART_STATE_MANAGER";
